import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { get } from 'lodash';
import moment from 'moment';

const PartialSaleInterestNotification = ({ notification, isRead, onClick, onMarkAsRead }) => {
  const intl = useIntl();
  const actorName = get(notification, 'actor.allowed_name', 'Someone');
  const partialSaleDetails = get(notification, 'notifiable.partial_sale_listing.segment_details', 'your partial sale');
  const createdAt = get(notification, 'createdAt');
  
  return (
    <div
      className={`p-4 border-b border-succession-border cursor-pointer hover:bg-succession-hover-bg transition-colors ${
        !isRead ? 'bg-succession-primary-10 border-l-4 border-l-succession-primary' : ''
      }`}
      onClick={onClick}
    >
      <div className="flex items-start space-x-3">
        {/* Icon */}
        <div className="flex-shrink-0">
          <div className="w-10 h-10 bg-succession-primary-10 rounded-full flex items-center justify-center">
            <svg className="w-5 h-5 text-succession-primary" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
            </svg>
          </div>
        </div>
        
        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <p className="text-sm font-medium text-succession-text-primary">
              {intl.formatMessage({ id: 'succession.notifications.partial_sale.title' })}
            </p>
            {!isRead && (
              <div className="w-2 h-2 bg-succession-primary rounded-full"></div>
            )}
          </div>
          
          <p className="text-sm text-succession-text-secondary mt-1">
            {intl.formatMessage({ id: 'succession.notifications.partial_sale.body' }, { name: <span key="name" className="font-medium">{actorName}</span>, details: partialSaleDetails })}
          </p>
          
          <div className="flex items-center justify-between mt-2">
            <p className="text-xs text-succession-text-muted">
              {moment(createdAt).fromNow()}
            </p>
            
            <button
              onClick={(e) => {
                e.stopPropagation();
                // This drawer renders only for findbob_modernization tenants, whose
                // current experience is /succession/my_partial_sales (the seller's own
                // listings + inquiries) — not the legacy /users/:user_name/partial_sales.
                window.location.href = '/succession/my_partial_sales';
              }}
              className="text-xs bg-succession-primary text-white px-3 py-1 rounded-md hover:bg-succession-primary-hover transition-colors"
            >
              {intl.formatMessage({ id: 'succession.notifications.partial_sale.view_partial_sales' })}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

PartialSaleInterestNotification.propTypes = {
  notification: PropTypes.object.isRequired,
  isRead: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onMarkAsRead: PropTypes.func.isRequired,
};

export default PartialSaleInterestNotification;
